import type {TeamsAndGroupsGroup} from './admin-group-type-page';

export const getEntityId = (value: any): string => {
  if (typeof value === 'object') return value?.id || value?._id || '';
  return value || '';
};

export const removeGroupFromResponse = (response: any, groupId: string) => {
  const removeGroup = (groups: TeamsAndGroupsGroup[]) =>
    groups.filter((group) => getEntityId(group) !== groupId);

  if (Array.isArray(response)) return removeGroup(response);
  if (Array.isArray(response?.results)) {
    return {...response, results: removeGroup(response.results)};
  }
  if (Array.isArray(response?.data)) {
    return {...response, data: removeGroup(response.data)};
  }

  return response;
};

const normalizeTypeName = (name = '') => name.trim().toLowerCase();

export const isProtectedGroupType = (type: any) => {
  const name = normalizeTypeName(type?.name);

  return (
    type?.isDefault === true ||
    type?.isDefault === 'true' ||
    name === 'department' ||
    name === 'departments'
  );
};

export const shouldDeleteOrphanedGroupType = (
  type: any,
  groups: TeamsAndGroupsGroup[],
  deletedGroupId: string,
) => {
  const typeId = getEntityId(type);
  if (!typeId || isProtectedGroupType(type)) return false;

  return !groups.some(
    (group) =>
      getEntityId(group) !== deletedGroupId &&
      getEntityId(group.groupType) === typeId,
  );
};
